<main class="container-fluid">
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <h4 class="mb-0">Counselling Presentation
            <mat-chip-list *ngIf="isEditMode" class="d-inline ms-2">
              <mat-chip color="warn" selected>
                <mat-icon>edit</mat-icon>
                Edit Mode
              </mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="isViewMode" class="d-inline ms-2">
              <mat-chip color="primary" selected>
                <mat-icon>visibility</mat-icon>
                View Mode
              </mat-chip>
            </mat-chip-list>
          </h4>
          <small *ngIf="isLoadingExistingData" class="text-muted">
            <mat-spinner diameter="16" class="d-inline"></mat-spinner>
            Loading presentation data...
          </small>
        </div>

        <button mat-raised-button color="accent"
                (click)="navigateToList()"
                permission="Counselling Presentation"
                [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
          <mat-icon>list</mat-icon>
          View All Counselling Presentations
        </button>
      </div>

      <div class="card-body ">
        <div class="row mx-2">

          <!-- Centre Dropdown (searchable + multi-select + select-all) -->
          <div class="col-md-3 mt-2">
            <app-searchable-select
              [options]="centresWithAll$ | async"
              displayKey="centreName"
              [valueKey]="'centreCode'"
              [multiple]="true"
              [hideSelectAllOption]="true"
              placeholder="Enter Centre Name"
              label="Select Centre(s)"
              [selectedValue]="selectedCentreObjects"
              (selectionChange)="onCentresSelected($event)"
              [isDisabled]="isViewMode"
            ></app-searchable-select>
          </div>

          <!-- Date Range Picker -->
          <mat-form-field appearance="outline" class="col-md-4 mt-2">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [disabled]="isViewMode">
              <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date" [disabled]="isViewMode">
              <input matEndDate [(ngModel)]="mEndDate" placeholder="End date" [disabled]="isViewMode">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isViewMode"></mat-datepicker-toggle>
            <mat-date-range-picker #picker [disabled]="isViewMode"></mat-date-range-picker>
          </mat-form-field>

          <!-- Sections Dropdown -->
          <mat-form-field appearance="outline" class="col-md-3 mt-2">
            <mat-label>Show Sections</mat-label>

            <mat-select multiple [(ngModel)]="selectedComponents" (selectionChange)="onComponentsChange()" [disabled]="isViewMode">

              <!-- Custom trigger display -->
              <mat-select-trigger>
                <ng-container *ngIf="selectedComponents.length > 0">
                  {{ getFirstSelectedLabel() }}
                  <span *ngIf="selectedComponents.length > 1" class="text-muted">
          + {{ selectedComponents.length - 1 }} other{{ selectedComponents.length > 2 ? 's' : '' }}
        </span>
                </ng-container>
              </mat-select-trigger>

              <!-- Select All Option -->
              <mat-option (click)="toggleAllSelection(); $event.stopPropagation()">
                <strong>Select All</strong>
              </mat-option>
              <mat-divider></mat-divider>

              <!-- Component Options -->
              <mat-option *ngFor="let component of components" [value]="component.id">
                {{ component.label }}
              </mat-option>

            </mat-select>
          </mat-form-field>

          <!-- Action Buttons -->
          <div class="col-md-2 mt-2" *ngIf="!isViewMode">

            <button mat-mini-fab color="accent"
                    (click)="Search()"
                    matTooltip="Search">
              <mat-icon>search</mat-icon>
            </button>

            &nbsp;

            <button mat-mini-fab color="warn"
                    (click)="Clear()"
                    matTooltip="Clear">
              <mat-icon>clear</mat-icon>
            </button>

            &nbsp;

            <button mat-mini-fab color="primary"
                    (click)="Save()"
                    [matTooltip]="isEditMode ? 'Update Counselling Presentation' : 'Save Counselling Presentation'"
                    [disabled]="!searchPressed">
              <mat-icon>{{ isEditMode ? 'update' : 'save' }}</mat-icon>
            </button>

            &nbsp;

            <button mat-mini-fab
                    style="background-color: #673ab7; color: white;"
                    (click)="openPhotoGallery()"
                    matTooltip="View Photo Gallery"
                    [disabled]="!searchPressed">
              <mat-icon>photo_library</mat-icon>
            </button>

          </div>

        </div>

        <!-- Content Area -->
        <div class="row mx-3 mt-4">
          <div class="col-12">

            <p *ngIf="!searchPressed"
               class="text-muted text-center">
              Please select a centre and date range,
              Then click search to view the counselling presentation.
            </p>

            <!-- Dynamic Sections -->
            <div *ngIf="searchPressed">
              <div *ngFor="let component of components" >
                <div *ngIf="isComponentSelected(component.id)"
                     class="card mb-3 p-3 shadow-sm ">
                  <h3>{{ component.label }}</h3>
                  <ng-container
                  *ngIf="component.label === 'Dashboard'">
                    <app-mis-counselling2
                      [selectedCentreCodes]="confirmedCentres"
                      [startDate]="confirmedStartDate"
                      [endDate]="confirmedEndDate"
                      [isNestedComponent]="true"
                      [isViewMode]="isViewMode"
                      [counsellorRemarks]="dashboardRemarks"
                      (remarksChange)="onDashboardRemarksChange($event)">
                    </app-mis-counselling2>
                  </ng-container>

                  <!-- Gallery Section -->
                  <ng-container *ngIf="component.label === 'Gallery'">
                    <div *ngIf="selectedImagesForSave.length === 0" class="text-center py-4">
                      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #999;">
                        photo_library
                      </mat-icon>
                      <p class="text-muted mt-2">No images selected</p>
                      <button *ngIf="!isViewMode" mat-raised-button color="accent" (click)="openPhotoGallery()">
                        <mat-icon>add_photo_alternate</mat-icon>
                        Select Images from Gallery
                      </button>
                    </div>

                    <div *ngIf="selectedImagesForSave.length > 0">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <span class="badge badge-primary" style="font-size: 14px; padding: 8px 16px;">
                            {{ selectedImagesForSave.length }} Image(s) Selected
                          </span>
                        </div>
                        <div *ngIf="!isViewMode">
                          <button mat-raised-button color="accent" (click)="openPhotoGallery()" class="mr-2">
                            <mat-icon>add</mat-icon>
                            Add More
                          </button>
                          <button mat-raised-button color="warn" (click)="clearGallery()">
                            <mat-icon>clear_all</mat-icon>
                            Clear All
                          </button>
                        </div>
                      </div>

                      <!-- Gallery Grid -->
                      <div class="gallery-grid">
                        <div *ngFor="let image of selectedImagesForSave; let i = index" class="gallery-item">
                          <div class="image-container">
                            <img [src]="image.url"
                                 [alt]="image.fileName"
                                 (click)="openImageInNewTab(image.url)"
                                 class="gallery-image">
                            <div class="image-overlay" *ngIf="!isViewMode">
                              <button mat-mini-fab color="warn"
                                      (click)="removeImageFromGallery(i)"
                                      class="remove-btn">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </div>
                          <div class="image-info">
                            <div class="image-filename" [title]="image.fileName">
                              {{ image.fileName }}
                            </div>
                            <div class="image-meta" *ngIf="image.centreName">
                              <mat-icon class="meta-icon">location_on</mat-icon>
                              {{ image.centreName }}
                            </div>
                            <div class="image-meta" *ngIf="image.description">
                              <mat-icon class="meta-icon">description</mat-icon>
                              {{ image.description }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container
                    *ngIf="component.label === 'Group Topics'">
                    <!-- Loading group topics -->
                    <div *ngIf="isLoadingGroupTopics" class="text-center py-3">
                      <mat-spinner diameter="32" class="d-inline"></mat-spinner>
                      <p class="text-muted mt-2">Loading group topics...</p>
                    </div>

                    <div *ngIf="!isLoadingGroupTopics">
                      <div *ngIf="uniqueGroupTopics.length > 0" class="mb-3">
                        <div class="d-flex align-items-center mb-2">
                          <span class="badge" style="font-size: 13px; padding: 6px 12px; background-color: #3f51b5; color: white;">
                            {{ uniqueGroupTopics.length }} Topic(s) Covered in Sessions
                          </span>
                        </div>
                        <mat-chip-list>
                          <mat-chip *ngFor="let topic of uniqueGroupTopics"
                                    color="primary" selected
                                    style="font-size: 13px;">
                            {{ topic }}
                          </mat-chip>
                        </mat-chip-list>
                      </div>
                      <div *ngIf="uniqueGroupTopics.length === 0" class="text-muted mb-2">
                        No group session topics found for the selected date range and centre(s).
                      </div>
                      <app-group-session-topics-list
                        [isVisibilePresentational]="true"
                        [isNestedComponent]="true"
                        [selectedCentreCodes]="confirmedCentres"
                        [startDate]="confirmedStartDate"
                        [endDate]="confirmedEndDate"
                        [coveredTopics]="uniqueGroupTopics"
                      ></app-group-session-topics-list>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="component.label === 'Highlights'">
                    <app-counselling-highlight-list
                      [selectedCentreCodes]="confirmedCentres"
                      [startDate]="confirmedStartDate"
                      [endDate]="confirmedEndDate"
                      [isNestedComponent]="true">
                    </app-counselling-highlight-list>
                  </ng-container>
                  <ng-container
                    *ngIf="component.label === 'Remarks'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Remarks</mat-label>
                      <textarea matInput placeholder="Enter remarks" [(ngModel)]="remarks" rows="5" [readonly]="isViewMode"></textarea>
                    </mat-form-field>
                  </ng-container>

                  <ng-container
                    *ngIf="component.label === 'Assessment Charts'">
                    <app-counselling-assessment-charts
                      [selectedCentreCodes]="confirmedCentres"
                      [startDate]="confirmedStartDate"
                      [endDate]="confirmedEndDate"
                      [isNestedComponent]="true">
                    </app-counselling-assessment-charts>
                  </ng-container>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</main>
